/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/fighter_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-.5-7.586v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zm22.5 0h-7.086l7.086-7.086v7.086zM16 28.586L3.414 16 16 3.414 28.586 16 16 28.586z"/><path pid="1" d="M18.068 15.138v1.725h-.115L16 11l-1.953 5.861h-.115V15.137h-.69v2.759a.346.346 0 00.691 0v-.346h1.724v.346h.689v-.346h1.724v.346a.346.346 0 00.692 0v-2.759l-.694.001zM16 18.932a.344.344 0 00-.345.344v1.381a.345.345 0 00.69-.003v-1.379a.344.344 0 00-.345-.343z"/>'
  }
})
